// src/components/SuccessStories.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function SuccessStories() {
  const slides = [
    {
      id: 1,
      quote: `People do not buy goods and services. They buy relationships, stories, and experiences. — Seth Godin`,
      imageSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    },
    {
      id: 2,
      quote: `Your brand is what people say about you when you're not in the room. — Jeff Bezos`,
      imageSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    },
    {
      id: 3,
      quote: `People will forget what you said, people will forget what you did, but people will never forget how you made them feel. - Maya Angelou`,
      imageSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    },
    {
      id: 4,
      quote: `The future of advertising is the Internet. - Bill Gates`,
      imageSrc: 'https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c',
    }
  ];

  return (
    <>
      <section className="success-stories container">
        <h2 className="academy-title has-text-centered">
          <span>Where Brands and Talents</span>
          <span>Flourish Together</span>
        </h2>

        <div className="busy-wrapper">
          <Swiper
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={10}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }}
            pagination={{ clickable: true, el: '.swiper-pagination' }}
            loop
            className="swiper-container success-story-items"
          >
            {slides.map(s => (
              <SwiperSlide key={s.id} style={{ width: '1152px' }}>
                <div className="story-item">
                  <div className="story-item-inner container section no-vertical-padding">
                    <div className="story-left">
                      <div className="story-image-container">
                        <div className="story-image-inner">
                          <img
                            alt="Story image"
                            src={s.imageSrc}
                            className="story-image"
                            width="463"
                            height="637"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="story-right">
                      <div className="story-right-inner">
                        <div className="open-quote">“</div>
                        <div>
                          <div className="story-text">
                            {s.quote}
                            <span className="close-quote">”</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* navigation buttons */}
            <div className="swiper-button-prev is-large is-hidden-mobile">
              <span className="icon is-normal" style={{ fontSize: '24px' }}>
                <svg viewBox="0 0 24 24">
                  <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                </svg>
              </span>
            </div>
            <div className="swiper-button-next is-large is-hidden-mobile">
              <span className="icon is-normal" style={{ fontSize: '24px' }}>
                <svg viewBox="0 0 24 24">
                  <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                </svg>
              </span>
            </div>

            {/* pagination bullets container */}
            <div className="swiper-pagination" />
          </Swiper>
        </div>
      </section>

      {/* appended “How to Get There” section */}
      <section className="safety section no-vertical-padding">
        <div className="container">
          <h2 className="title get-started-upspacing">How to Get There</h2>
          <div className="safety-items">
            <div className="safety-item">
              <div className="safety-item-icon">
                <span className="icon is-medium" style={{ fontSize: 32 }}>
                  <svg viewBox="0 0 24 24">
                    <path d="M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z" />
                  </svg>
                </span>
              </div>
              <span className="safety-item-title title-3">
                Market Insights
              </span>
            </div>

            <div className="safety-item">
              <div className="safety-item-icon">
                <span className="icon is-medium" style={{ fontSize: 32 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="m12.099 18.217 4.735 2.864c.868.525 1.929-.25 1.7-1.232l-1.255-5.386 4.188-3.628c.765-.662.354-1.917-.65-1.997l-5.512-.468-2.156-5.09c-.388-.923-1.712-.923-2.1 0L8.893 8.36l-5.512.467c-1.004.08-1.415 1.335-.65 1.997l4.188 3.629-1.256 5.386c-.228.981.833 1.757 1.7 1.232l4.736-2.853z" />
                  </svg>
                </span>
              </div>
              <span className="safety-item-title title-3">
                Strategic Branding
              </span>
            </div>

            <div className="safety-item">
              <div className="safety-item-icon">
                <span className="icon is-medium" style={{ fontSize: 32 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="m12.099 18.217 4.735 2.864c.868.525 1.929-.25 1.7-1.232l-1.255-5.386 4.188-3.628c.765-.662.354-1.917-.65-1.997l-5.512-.468-2.156-5.09c-.388-.923-1.712-.923-2.1 0L8.893 8.36l-5.512.467c-1.004.08-1.415 1.335-.65 1.997l4.188 3.629-1.256 5.386c-.228.981.833 1.757 1.7 1.232l4.736-2.853z" />
                  </svg>
                </span>
              </div>
              <span className="safety-item-title title-3">
                Analytics & Results
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
